import { IconUsers } from "@tabler/icons-react"; // Folder icon for file manager context

const UserMenu = {
  id: "users",
  title: "Users",
  type: "item",
  url: "/portal/admin/users",
  icon: IconUsers, // Folder icon for file management
};

export default UserMenu;
